import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  TextField,
  DialogContent
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DonutLargeIcon from "@material-ui/icons/DonutLarge";
import PaymentIcon from "@material-ui/icons/Payment";
import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import {
  BUTTON_COPAY,
  BUTTON_EDIT_ESTIMATE_CLAIM,
  BUTTON_REVISE_ESTIMATE_CLAIM,
  BUTTON_ESTIMATE_CLAIM,
  BUTTON_PAYMENT_LINK,
  BUTTON_PAYMENT_PENDING,
  BUTTON_UPLOAD_DAMAGED_MOBILE,
  BUTTON_UPLOAD_INVOICE,
  BUTTON_UPLOAD_REPAIRED_MOBILE,
  CLAIM_STATUS_APPROVED_SLUG,
  CLAIM_STATUS_INITIATED_SLUG,
  CLAIM_STATUS_PARTIALLY_APPROVED,
  CLAIM_STATUS_REJECTED_SLUG,
  CLAIM_STATUS_SUBMITTED,
  DOCUMENT_TPYE_ID_ESTIMATE,
  DOCUMENT_TPYE_ID_INVOICE,
  DOCUMENT_TPYE_ID_MOBILE_PHOTOS,
  DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS,
  FORMAT_DD_MM_YYYY,
  PENDING_TEXT,
  SLUG_DAMAGED_MOBILE,
  SLUG_ESTIMATE_MOBILE,
  SLUG_INVOICE_MOBILE,
  SLUG_REPAIRED_MOBILE,
  UPLOAD_REPAIRED_INVOICE_PHOTO,
  UPLOAD_REPAIRED_MOBILE_PHOTO,
} from "../../constants/index";
import { convertDateTimeFormat } from "../../helpers/date";
import {
  getServiceCentreDetails,
  isCopaymentSkippedForClaim,
} from "../../helpers/proposal";
import { patchWebService, postWebService, getWebService } from "../../helpers/server";
import AdditionalDetails from "./additionalDetails";
import ClaimAmount from "./amount";
import DownloadIcon from "./downloadIcon";
import ReUploadButton from "./reUploadButton";
import ClaimStatus from "./status";
import { StyledTableCell, StyledTableRow, useStyles } from "./styles";
import UploadButton from "./uploadButton";
import ModalComp from "./ModalComp";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import MultipleImageDownloadIcon from "./multipleImageDownloadIcon";
import CommonModalComp from "./CommonModalComp";
import { makeStyles } from "@material-ui/core/styles";

function ListItem({
  classes: { borderRadius, capitalize, marginLeft, preferredClaim, timeslot },
  classes,
  downloadFile,
  handleEstimateClick,
  handlePaymentLinkClick,
  handleRemarksClick,
  index,
  item,
  uploadClickHandler,
  getClaimsList,
  claimData,
}) {
  const [berOpt, setBerOpt] = useState("");
  const fetchApi = async (payload, id) => {
    try {
      const resp = await postWebService(`claim/update/${id}`, payload);
      getClaimsList();
    } catch (err) {}
  };
  const fetchReasons = async () => {
    try {
      const response = await getWebService(`claims/reasons`);
      const responseData = response.data;
      if (responseData.success && responseData.data) {
        // Transform the API response into the required format for dropdown
        const formattedReasons = Object.keys(responseData.data).map((key) => ({
          value: key,
          label: responseData.data[key],
        }));
        setReasonsList(formattedReasons);
      }
    } catch (err) {
      console.error("Error fetching reasons:", err);
    }
  };

  const fetchRemark = async (claimId) => {
    try {
      const response = await getWebService(`claims/${claimId}/remarks`);
      if (response.data.success) {
        // Set remarks from `items` array inside `data`
        setRemarks(response.data.data.items || []); // Assuming `items` contains the array of remarks
      } else {
        // Handle if remarks are not found or any other issue
        setRemarks([]);
        console.error("No remarks found for this claim.");
      }
    } catch (error) {
      console.error("Error fetching remarks:", error);
      setRemarks([]); // Clear remarks if there's an error
    }
  };
  
  // Function to add a remark
  const addRemarkToClaim = async (claimId) => {
    const payload = {
      remark: newRemark,
      added_by_platform: "Service Centre", // Adding the required field
    };
    
    try {
      const response = await postWebService(`claims/${claimId}/remarks`, payload);
      if (response.data.success) {
        // Clear the new remark field
        setNewRemark("");
        // Fetch updated remarks list
        fetchRemark(claimId);
        toast.success("Remark added successfully!");
      } else {
        toast.error("Failed to add remark, please try again.");
      }
    } catch (error) {
      console.error("Error adding remark:", error);
      toast.error("Error adding remark, please try again.");
    }
  };

  // Function to add a new remark
  const handleAddRemark = (claimId) => {
    if (!newRemark.trim()) {
      toast.error("Remark cannot be empty.");
      return;
    }

    // Call the API to add remark
    addRemarkToClaim(claimId);
  };


  const handleBerSelect = async (e, id) => {
    handleOpenModal();
    setBerOpt(e.target.value);
  };
  const handleCancelClaim = async (id) => {
    handleOpenModal();
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [reasonsList, setReasonsList] = useState([]);
  const [remarksModalOpen, setRemarksModalOpen] = useState(false); // Controls the modal state
  const [remarks, setRemarks] = useState([]); // Stores fetched remarks
  const [newRemark, setNewRemark] = useState("");

  const handleOpenModal = () => {
    setModalOpen(true);
    fetchReasons();
  };

  const handleCloseModal = () => {
    setBerOpt("");
    setModalOpen(false);
  };

  const handleConfirm = (id, type) => {
    let payload;
    if (type === "ber") {
      payload = {
        ber_decision: berOpt,
        update_type: "ber_decision",
      };
    } else {
      payload = {
        update_type: "cancel_claim",
        cancellation_reason: selectedReason, 
        cancelled_by: "Service Centre"
      };
    }
    fetchApi(payload, id);
    setModalOpen(false);
  };
  
  const history = useHistory();
  const redirectRoute = (item, type) => {
    if (!type) {
      history.push(`/repairEstimate?claimId=${item.id}`);
    } else {
      history.push({
        pathname: `/repairEstimate`,
        search: `?claimId=${item.id}`,
        state: { item },
      });
    }
  };
  const handleResendPaymentLink = async (id) => {
    let resendPayload = {
      entity: "claim",
      entity_id: id,
    };
    try {
      const resp = await postWebService(`payments/resend-link`, resendPayload);
      toast.success(resp.data.data.message);
    } catch (err) {
      toast.error("Something went wrong, please try again");
    }
  };

  const handleReasonChange = (e) => {
    setSelectedReason(e.target.value);
  };

  const useSelectStyles = makeStyles((theme) => ({
    select: {
      fontSize: "0.875rem",
    },
    menuItem: {
      fontSize: "0.875rem",
    },
    remarksModalContent: {
      minWidth: "500px", // Set minimum width for modal
      maxHeight: "80vh", // Restrict max height
      overflowY: "auto", // Enable scroll if content overflows
      padding: (theme && theme.spacing) ? theme.spacing(2) : '16px', // Padding for inner content (fallback added)
    },
    remarkItem: {
      marginBottom: (theme && theme.spacing) ? theme.spacing(2) : '8px', // Space between remarks (fallback added)
      paddingBottom: (theme && theme.spacing) ? theme.spacing(1) : '4px',
      borderBottom: `1px solid ${(theme && theme.palette) ? theme.palette.grey[300] : 'gray'}`, // Bottom border for each remark (fallback added)
    },
    remarkText: {
      fontSize: "14px",
      marginBottom: (theme && theme.spacing) ? theme.spacing(0.5) : '4px',
    },
    remarkDetails: {
      fontSize: "12px",
      color: (theme && theme.palette) ? theme.palette.text.secondary : 'gray',
    },
  }));
  
  
  const selectClasses = useSelectStyles();

  // Function to open remarks modal and fetch existing remarks
  const handleOpenRemarksModal = (item) => {
    fetchRemark(item.id); // Ensure no undefined issues
    setRemarksModalOpen(true);
  };

  // Function to close remarks modal
  const handleRemarksModalClose = () => {
    setRemarksModalOpen(false);
    setNewRemark(""); // Clear the new remark field
  };
  
  return (
    <StyledTableRow name="row" key={index} className={""}>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        {getServiceCentreDetails() == item.service_centre_id && (
          <Box className={preferredClaim}>
            {convertDateTimeFormat(item?.created_at, FORMAT_DD_MM_YYYY)}
          </Box>
        )}
        {getServiceCentreDetails() != item.service_centre_id && (
          <Box className={timeslot}>
            {convertDateTimeFormat(item?.created_at, FORMAT_DD_MM_YYYY)}
          </Box>
        )}
      </StyledTableCell>
      <StyledTableCell className={`${classes.td}`} component="th" scope="row">
        {item?.id}
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        <ClaimAmount item={item} />
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        {item?.approved_amount
          ? `₹${Number(item?.approved_amount).toLocaleString("en")}`
          : item?.status.toLowerCase() === CLAIM_STATUS_REJECTED_SLUG
          ? "-"
          : PENDING_TEXT}
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        {`${convertDateTimeFormat(item?.created_at, FORMAT_DD_MM_YYYY)}`}
      </StyledTableCell>
      <StyledTableCell
        className={`${classes.tdAdditionalDetails}`}
        component="th"
        scope="row"
      >
        {item?.name} 
        {/* <br />
        {item?.mobile} */}
      </StyledTableCell>
      <StyledTableCell className={`${classes.tdAdditionalDetails}`} scope="row">
        <AdditionalDetails item={item} />
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${item?.active}`}>
      <ClaimStatus item={item} handleRemarksClick={() => handleOpenRemarksModal(item)} />
      </StyledTableCell>
      <StyledTableCell className={classes.td} style={{ width: "10%" }}>
        <Box layout="row" display="flex">
          <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_MOBILE_PHOTOS}
            downloadFile={downloadFile}
            item={item}
          />

          <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_ESTIMATE}
            downloadFile={downloadFile}
            item={item}
          />

          <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_INVOICE}
            downloadFile={downloadFile}
            item={item}
          />

          {/* <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS}
            downloadFile={downloadFile}
            item={item}
          /> */}
          <MultipleImageDownloadIcon
            downloadFile={downloadFile}
            item={claimData[index]}
          />
        </Box>
        <Box layout="row" display="flex">
          {/* <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_MOBILE_PHOTOS}
            modalKey={SLUG_DAMAGED_MOBILE}
            text={BUTTON_UPLOAD_DAMAGED_MOBILE}
            uploadClickHandler={uploadClickHandler}
          />

          <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_ESTIMATE}
            modalKey={SLUG_ESTIMATE_MOBILE}
            text={BUTTON_ESTIMATE_CLAIM}
            uploadClickHandler={uploadClickHandler}
          /> */}

          <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_INVOICE}
            modalKey={SLUG_INVOICE_MOBILE}
            text={BUTTON_UPLOAD_INVOICE}
            uploadClickHandler={uploadClickHandler}
          />

          <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS}
            modalKey={SLUG_REPAIRED_MOBILE}
            text={BUTTON_UPLOAD_REPAIRED_MOBILE}
            uploadClickHandler={uploadClickHandler}
          />
        </Box>

        {(item?.status.toLowerCase() === CLAIM_STATUS_APPROVED_SLUG ||
            item.status === "BER Approved") && (
          <Box layout="row" display="flex" flexDirection="column">
            {/* First Row: Upload Buttons */}
            <Box layout="row" display="flex" mb={1}>
              <UploadButton
                documentTypeId={DOCUMENT_TPYE_ID_INVOICE}
                item={item}
                slug={SLUG_INVOICE_MOBILE}
                text={BUTTON_UPLOAD_INVOICE}
                tooltip={UPLOAD_REPAIRED_INVOICE_PHOTO}
                uploadClickHandler={uploadClickHandler}
              />
              <UploadButton
                documentTypeId={DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS}
                item={item}
                slug={SLUG_REPAIRED_MOBILE}
                text={BUTTON_UPLOAD_REPAIRED_MOBILE}
                tooltip={UPLOAD_REPAIRED_MOBILE_PHOTO}
                uploadClickHandler={uploadClickHandler}
              />
            </Box>

            {/* Second Row: Revise Estimate Button */}
            <Box layout="row" display="flex">
              <Button
                variant="contained"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={(event) => redirectRoute(item, "edit")}
                data-tip={`Click to edit estimate details`}
              >
                
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                {BUTTON_REVISE_ESTIMATE_CLAIM}
              </Button>
              <ReactTooltip html={true} />
            </Box>
          </Box>
        )}


        {item?.status.toLowerCase().replace(" ", "_") ===
          CLAIM_STATUS_INITIATED_SLUG && (
          <Box layout="row" display="flex">
            {item.copayment_amount > 0 && (
              <Box>
                <Button
                  variant="outlined"
                  color={
                    isCopaymentSkippedForClaim(item.razorpay_order_id)
                      ? "primary"
                      : "secondary"
                  }
                  size={"small"}
                  className={`${borderRadius} ${marginLeft} ${capitalize}`}
                  data-tip={
                    isCopaymentSkippedForClaim(item.razorpay_order_id)
                      ? `Co-payment of ₹${Number(
                          item?.copayment_amount
                        ).toLocaleString(
                          "en"
                        )} need to collect from the customer`
                      : `Co-payment of ₹${Number(
                          item?.copayment_amount
                        ).toLocaleString("en")} already done`
                  }
                >
                  {isCopaymentSkippedForClaim(item.razorpay_order_id) && (
                    <CancelIcon style={{ margin: "3px 6px" }} />
                  )}
                  {!isCopaymentSkippedForClaim(item.razorpay_order_id) && (
                    <CheckCircleIcon
                      style={{ margin: "3px 6px", color: "green" }}
                    />
                  )}
                  {BUTTON_COPAY}
                </Button>
                <ReactTooltip />
              </Box>
            )}
            <Box>
              <Button
                variant="contained"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={(event) => redirectRoute(item)}
                data-tip={`Click to estimate this claim`}
              >
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                {BUTTON_ESTIMATE_CLAIM}
              </Button>
              <ReactTooltip html={true} />
            </Box>
          </Box>
        )}
        {(item?.status.toLowerCase().replace(" ", "_") ===
          CLAIM_STATUS_SUBMITTED || item?.status === 'Need more documents') && (
          <Box>
            <Button
              variant="contained"
              color="secondary"
              size={"small"}
              className={`${borderRadius} ${marginLeft} ${capitalize}`}
              onClick={(event) => redirectRoute(item, "edit")}
              data-tip={`Click to edit estimate details`}
            >
              <DonutLargeIcon style={{ margin: "3px 6px" }} />
              {BUTTON_EDIT_ESTIMATE_CLAIM}
            </Button>
            <ReactTooltip html={true} />
          </Box>
        )}

        {item.status === "BER-Repair" &&
          (!item.repair_payment_successful && !item.repair_payment_link ? (
            <Box>
              <Button
                variant="contained"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={(event) => handlePaymentLinkClick(event, item)}
                data-tip={`Click to send repair partial payment link for this claim`}
              >
                <PaymentIcon style={{ margin: "3px 6px" }} />
                {BUTTON_PAYMENT_LINK}
              </Button>
              <ReactTooltip html={true} />
            </Box>
          ) : (
            <Box>
              <Button
                variant="outlined"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                data-tip={`Customer partial payment of Rs.${item.repair_amount} is pending`}
              >
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                {BUTTON_PAYMENT_PENDING}
              </Button>
              <ReactTooltip html={true} />
              <Button
                variant="outlined"
                color="primary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={() => handleResendPaymentLink(item.id)}
                style={{ marginTop: "1rem" }}
                data-tip={`Resend  the payment link to the customer`}
              >
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                Resend Payment Link
              </Button>
              <ReactTooltip html={true} />
            </Box>
          ))}

        {item.status_slug === CLAIM_STATUS_PARTIALLY_APPROVED &&
          (!item.repair_payment_successful && !item.repair_payment_link ? (
            <Box>
              <Button
                variant="contained"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={(event) => handlePaymentLinkClick(event, item)}
                data-tip={`Click to send repair partial payment link for this claim`}
              >
                <PaymentIcon style={{ margin: "3px 6px" }} />
                {BUTTON_PAYMENT_LINK}
              </Button>
              <ReactTooltip html={true} />
            </Box>
          ) : (
            <Box>
              <Button
                variant="outlined"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                data-tip={`Customer partial payment of Rs.${item.repair_amount} is pending`}
              >
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                {BUTTON_PAYMENT_PENDING}
              </Button>
              <ReactTooltip html={true} />
              <Button
                variant="outlined"
                color="primary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={() => handleResendPaymentLink(item.id)}
                style={{ marginTop: "1rem" }}
                data-tip={`Resend  the payment link to the customer`}
              >
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                Resend Payment Link
              </Button>
              <ReactTooltip html={true} />
            </Box>
          ))}
        {item.status === "BER" && (
          <>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select BER Case
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={berOpt}
                label="berOpt"
                onChange={(e) => handleBerSelect(e, item.id)}
              >
                <MenuItem value="settle">Settle</MenuItem>
                <MenuItem value="repair">Repair</MenuItem>
              </Select>
            </FormControl>
            <ModalComp
              open={modalOpen}
              onClose={handleCloseModal}
              onConfirm={() => handleConfirm(item.id, "ber")}
              title="Confirmation"
            >
              {berOpt === "repair"
                ? "Are you Sure? You are choosing to repair the mobile."
                : "Are you Sure? You are choosing to Settle the benefit value."}
            </ModalComp>
          </>
        )}

        {((item.status === "Claim Initiated" || (item?.status.toLowerCase().replace(" ", "_") ===
          CLAIM_STATUS_SUBMITTED || item?.status === 'Need more documents')) && getServiceCentreDetails() == item.service_centre_id) && (
          <>
            <Button
              variant="outlined"
              color="secondary"
              size={"small"}
              className={`${borderRadius} ${marginLeft} ${capitalize}`}
              data-tip={`Cancel the claim request`}
              onClick={() => handleCancelClaim(item.id)}
              style={{ marginTop: "1rem" }}
            >
              Cancel Claim
            </Button>
            <CommonModalComp
              open={modalOpen}
              onClose={handleCloseModal}
              onSubmit={() => handleConfirm(item.id, "cancel_claim")}
              title="Cancel Claim Reason"
              contentComponent={
                <FormControl fullWidth>
                  <InputLabel id="reason-select-label">Select Reason</InputLabel>
                  <Select
                    labelId="reason-select-label"
                    value={selectedReason}
                    onChange={handleReasonChange}
                    classes={{ root: selectClasses.select }} // Use selectClasses for the dropdown
                  >
                    {reasonsList.map((reason, index) => (
                      <MenuItem key={index} value={reason.label} className={selectClasses.menuItem}>
                        {reason.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              }
              confirmButtonText="Submit"
              cancelButtonText="Close"
            />
          </>
        )}

<CommonModalComp
  open={remarksModalOpen}
  onClose={handleRemarksModalClose}
  onSubmit={() => handleAddRemark(item.id)} // Pass the claim ID
  title="Remarks"
  contentComponent={
    <Box className={selectClasses.remarksModalContent}>
      {/* Existing remarks list */}
      {remarks.map((remarkObj, index) => (
        <Box key={index} className={selectClasses.remarkItem}>
          <Typography variant="body2" className={selectClasses.remarkText}>
            {remarkObj.remark} {/* Display the remark text */}
          </Typography>
          <Typography variant="body2" className={selectClasses.remarkDetails}>
            {`Added By: ${remarkObj.added_by_platform || "N/A"} on ${convertDateTimeFormat(remarkObj.created_at, "DD-MM-YYYY hh:mm A")}`}
          </Typography>
        </Box>
      ))}

      {/* Input for adding new remark */}
      <TextField
        label="Add Remark"
        variant="outlined"
        fullWidth
        value={newRemark}
        onChange={(e) => setNewRemark(e.target.value)}
        style={{ marginTop: "16px" }}
      />
    </Box>
  }
  confirmButtonText="Add Remark"
  cancelButtonText="Close"
/>

      </StyledTableCell>
    </StyledTableRow>
  );
}

export default withStyles(useStyles, { withTheme: true })(ListItem);
